import {
  IssueFilteringDtoOptions,
  IssueSortingDtoOptions,
  Issues200Response,
  IssueSearchFilteringDtoOptions,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';
import { isSourceEntityFilterPresent } from './should-use-post-search';

export type ListIssueQueryParameters = {
  sort?: IssueSortingDtoOptions;
  filter?: IssueSearchFilteringDtoOptions;
  page?: number;
  limit?: number;
  /** When true, always routes through POST /issues/search regardless of filter shape. */
  usePost?: boolean;
};

export function useIssues(props: ListIssueQueryParameters) {
  const {
    page = 0,
    limit = 10,
    sort = {},
    filter = {},
    usePost = false,
  } = props;

  const api = useApi();

  const postSearch = usePost || isSourceEntityFilterPresent(filter);

  return useQuery<Issues200Response, ExtendedAxiosError>({
    queryKey: ['issues', sort, filter, page, limit, postSearch],
    queryFn: () =>
      postSearch
        ? api.issuesApi
            .searchIssues({
              sort,
              filter: filter as IssueSearchFilteringDtoOptions,
              page,
              limit,
            })
            .then((r) => r.data)
        : api.issuesApi
            .issues(sort, filter as IssueFilteringDtoOptions, page, limit)
            .then((r) => r.data),
    meta: {
      handleError: true,
    },
  });
}
